import ArrowBackIcon from '@/icons/arrow-back';
import ArrowForwardIcon from '@/icons/arrow-forward';
import CloseIcon from '@/icons/close';
import { Dialog, Transition } from '@headlessui/react';
// import dynamic from 'next/dynamic';
import React, { Fragment } from 'react';
import { Carousel } from 'react-responsive-carousel';
// import { CarouselProps } from 'react-responsive-carousel';

// const Carousel = dynamic<Partial<CarouselProps>>(() =>
//   import('react-responsive-carousel').then((m) => m.Carousel)
// );

export interface IImageSliderModalProps {
  open: boolean;
  toggleModal: () => void;
  images: string[];
  initialSelected: number | null;
  title?: string;
}

export const ImageSliderModal = ({
  open,
  toggleModal,
  images,
  initialSelected,
}: IImageSliderModalProps) => {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto flex"
        onClose={toggleModal}
      >
        <div className="flex flex-1">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-90" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="flex flex-1">
              <div
                className="absolute right-8 top-8 cursor-pointer"
                style={{ zIndex: 100 }}
                role="button"
                onClick={toggleModal}
              >
                <CloseIcon className="h-6 w-6 fill-current text-white" />
              </div>

              <div className="flex flex-col flex-1 justify-end items-center overflow-hidden text-left align-middle transition-all transform  shadow-xl rounded-md relative">
                <Carousel
                  showIndicators={false}
                  showStatus={false}
                  selectedItem={initialSelected}
                  useKeyboardArrows
                  autoFocus
                  renderArrowPrev={(clickHandler, hasPrev) =>
                    hasPrev && (
                      <button
                        onClick={clickHandler}
                        className="absolute opacity-80 rounded-full flex items-center justify-center bg-opacity-30 bg-black hover:opacity-100 hover:bg-opacity-40 transition-colors text-white"
                        style={{
                          width: 48,
                          height: 48,
                          left: 10,
                          top: 'calc(50% - 24px)',
                          zIndex: 2,
                        }}
                      >
                        <ArrowBackIcon />
                      </button>
                    )
                  }
                  renderArrowNext={(clickHandler, hasNext) =>
                    hasNext && (
                      <button
                        onClick={clickHandler}
                        className="absolute opacity-80 rounded-full flex items-center justify-center bg-opacity-30 bg-black hover:opacity-100 hover:bg-opacity-40 transition-colors text-white"
                        style={{
                          width: 48,
                          height: 48,
                          right: 10,
                          top: 'calc(50% - 24px)',
                          zIndex: 2,
                        }}
                      >
                        <ArrowForwardIcon />
                      </button>
                    )
                  }
                  renderThumbs={(children) =>
                    children.map((_, index) => (
                      <img
                        key={index}
                        src={images[index]}
                        alt="Carousel Thumb"
                        className="object-cover h-14"
                      />
                    ))
                  }
                >
                  {images.map((image, index) => (
                    <div
                      className="flex object-contain"
                      key={String(index)}
                      style={{ height: '75vh' }}
                    >
                      <img
                        src={image}
                        className="h-full w-full object-contain"
                        alt="Carousel Images"
                      />
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};
